export const ADUNITS = {
	LABEL: {
		DEFAULT_UNIT: 'Default Units',
		BACKFILL_UNIT: 'Backfill Units',
		NO_MCM_UNIT: 'No MCM Units'
	},
	KEY: {
		DEFAULT_UNIT_KEY: 'defaultUnits',
		BACKFILL_UNIT_KEY: 'backfillUnits',
		NO_MCM_UNIT_KEY: 'noMcmUnits'
	}
};
